import React, { useEffect } from "react";
import { Modal, Typography, Card, Space, Avatar, Divider, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import { viewAdminProfile } from "../../../redux/reducer/AuthSlice";

const { Title, Text } = Typography;

const ViewProfileDetails = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { viewProfile, viewProfileLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (open) {
      dispatch(viewAdminProfile());
    }
  }, [open, dispatch]);

  return (
    <Modal
      title="Profile Details"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
    >
      {viewProfileLoading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            textAlign: "center",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            padding: "20px",
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            {/* Avatar */}
            <Avatar size={80} icon={<UserOutlined />} />

            {/* User Info */}
            <Title level={4} style={{ marginBottom: 0 }}>
              {viewProfile?.name_en || "N/A"}
            </Title>
            <Text type="secondary">{viewProfile?.email || "N/A"}</Text>

          

            {/* Additional Info (Optional) */}
           
          </Space>
        </Card>
      )}
    </Modal>
  );
};

export default ViewProfileDetails;

